import { z } from 'zod'

import { generateRandomString } from '@mntn-dev/utilities'
import type { ZodInfer } from '@mntn-dev/utility-types'

import {
  EmailAddressSchema,
  NameSchema,
  PhoneNumberSchema,
} from '../property.models.ts'
export const BillingContactIdSchema = z.string().brand('billing-contact')

export type BillingContactId = ZodInfer<typeof BillingContactIdSchema>

export const BillingContactId = (
  value: string = generateRandomString()
): BillingContactId => {
  return BillingContactIdSchema.parse(value)
}

export const BillingContactDomainSelectModelSchema = z.object({
  billingContactId: BillingContactIdSchema,
  firstName: NameSchema,
  lastName: NameSchema,
  email: EmailAddressSchema,
  phone: PhoneNumberSchema.optional(),
})

export type BillingContactDomainSelectModel = ZodInfer<
  typeof BillingContactDomainSelectModelSchema
>

export const BillingContactDomainInsertModelSchema =
  BillingContactDomainSelectModelSchema.omit({
    billingContactId: true,
  })

export type BillingContactDomainInsertModel = ZodInfer<
  typeof BillingContactDomainInsertModelSchema
>

export const BillingContactDomainUpdateModelSchema =
  BillingContactDomainSelectModelSchema

export type BillingContactDomainUpdateModel = ZodInfer<
  typeof BillingContactDomainUpdateModelSchema
>
